module.exports = __webpack_public_path__ + "img/grdf-lazy.a2490503.jpg";